import BaseApi from "./BaseApi";

class CardApi extends BaseApi {
    getIOSCardHome(mobile) {
        return this.httpGet('/h5/card/ios/cardHome', {mobile}, '获取卡片关系图失败')
    }
}

export default new CardApi();